import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "refreshRequestBtn", "9999"]

  connect() {
    this.controllerName = `app--stats--trackers--real-time--actions`
    this.numberController = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.tableCols = 6
    this.itemsOnPage = 200
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `desc`, field: `created_at_to_time` }
    this.range = 10
    this.hasFilter = false
    this.doIndexListHtml()
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {

    var btns = `<span class="mc-tooltip">
                  <button aria-expanded="false" aria-haspopup="true" data-range="30" class="btn btn-outline my-0" data-${this.controllerName}-target="refreshRequestBtn" data-action="click->${this.controllerName}#getRequestsRealTime" type="button">
                    <span class="material-icons md-dark">forward_30</span>
                  </button>
                  <span class="mc-tooltiptext">Atualizar 30 min</span>
                </span>
                <span class="mc-tooltip">
                  <button aria-expanded="false" aria-haspopup="true" data-range="10" class="btn btn-outline my-0" data-${this.controllerName}-target="refreshRequestBtn" data-action="click->${this.controllerName}#getRequestsRealTime" type="button">
                    <span class="material-icons md-dark">forward_10</span>
                  </button>
                  <span class="mc-tooltiptext">Atualizar 10 min</span>
                </span>
                <span class="mc-tooltip">
                  <button aria-expanded="false" aria-haspopup="true" data-range="5" class="btn btn-outline my-0" data-${this.controllerName}-target="refreshRequestBtn" data-action="click->${this.controllerName}#getRequestsRealTime" type="button">
                    <span class="material-icons md-dark">forward_5</span>
                  </button>
                  <span class="mc-tooltiptext">Atualizar 5 min</span>
                </span>`

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Requests Real Time</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                    <div class="card-actions ml-auto py-0">
                      ${btns}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-20 align-middle">Referer</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-30 align-middle">Controller Action</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle text-center">Status</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle text-center">DB Runtime</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle text-center">View Runtime</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle text-center">Duration</th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("app--stats--trackers--real-time--dashboard").actionsTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 6))
      if (controller.application.requests_real_time.length == 0) {
        controller.getRequestsRealTime()
      } else {
        controller.doDataTable()
      }
    })
  }

  doDataTable() {
    var current_requests = []

    if (this.hasFilter) {
      this.application.requests_real_time.forEach(element => {
        if (element.user_id == this.user_id) {
          current_requests[current_requests.length] = element
        }
      })
    } else {
      current_requests = this.application.requests_real_time
    }

    if (this.sort.mode == `asc`) {
      var requests = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_requests, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var requests = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_requests, this.sort.field)
    }

    if (requests.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(requests.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (requests[x] !== undefined) {
            internPage[internPage.length] = requests[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: requests.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.tableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Requests Enviados</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.requestTablePartial(element, data.length))
      });
    }
  }

  requestTablePartial(element, length) {

    if (element.status == "200" || element.status == "201" || element.status == "202") {
      var status = `<span class="mc-tooltip badge badge-secondary-success">${element.status}</span>`
    } else {
      var status = `<span class="mc-tooltip badge badge-secondary-danger">${element.status}</span>`
    }

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" data-path-referer="${element.path_referer}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" data-path-referer="${element.path_referer}">`
    }

    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer">
                      <span class="mb-0 mc-tooltip">
                        <span data-action="click->${this.controllerName}#goToURL">${element.path_referer}</span>
                        <span class="mc-tooltiptext mc-tooltiptext-right">${element.created_at_pretty}</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer">
                      <span class="mb-0 mc-tooltip">
                        <span>${element.controller_action}</span>
                        <span class="mc-tooltiptext mc-tooltiptext-right">${element.user_name}</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${status}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${this.numberController.numberMask(element.db_runtime)}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${this.numberController.numberMask(element.view_runtime)}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${this.numberController.numberMask(element.duration)}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="card-actions align-items-center justify-content-end py-0 f-065">
                        <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                        <div class="dropdown">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${pagination.itemsOnPage}</button>
                          <div class="dropdown-menu dropdown-menu-right menu">
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="200">200</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="400">400</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                          </div>
                        </div>
                        <span class="align-self-center mb-1 mr-2 text-muted">${pagination.fromItem}-${pagination.toItem} de ${pagination.totalItems}</span>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  getRequestsRealTime(ev) {
    this.bodyTableTarget.innerHTML = this.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 6)
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
    this.range = ev.currentTarget.dataset.range
    this.hasFilter = false

    var data = { tracker_request: { last_minutes: this.range }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/app/stats/trackers/requests/list_real_time"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this

    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          controller.application.requests_real_time = response.data.cln.requests
          controller.application.users_real_time = response.data.cln.users
        }
        controller.doDataTable()
        controller.getControllerByIdentifier("app--stats--trackers--real-time--users").doIndexListHtml()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)

      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  cleanCheckBox() {
    this.checkboxShowTargets.forEach(element => {
      element.checked = false
    });
    this.checked_id = ``
  }

  userCanUpdate(ticketId) {
    var ticket = {}
    this.application.in_process_tickets.forEach(element => {
      if (element.id == ticketId) {
        ticket = element
      }
    })
    var allowed = [ticket.owner_id, ticket.performer_id]
    if (allowed.includes(this.application.current_user.account_id) && this.stage != "done") {
      return true
    } else {
      return false
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.closest(`.itemRow`).dataset.pathReferer
    window.open(url, `_blank`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
